const footerData = {
    contact: {
        phone: "+355 69 2193113",
        address: "Tirane, Albania",
        email: "cliniusdental@gmail.com",
        website: "https://cliniusdental.com/",
    },
    copyright:
        "Clinius. <a href='https://example.com/' target='_blank' rel='noopener noreferrer'>All Rights Reserved.</a>",
    socials: [
        {
            id: 1,
            icon: "fab fa-facebook-f",
            link: "https://www.facebook.com",
            title: "Facebook",
        },
        {
            id: 2,
            icon: "fab fa-twitter",
            link: "https://www.twitter.com",
            title: "Twitter",
        },
        {
            id: 3,
            icon: "fab fa-instagram",
            link: "https://www.instagram.com",
            title: "Instagram",
        },
        {
            id: 4,
            icon: "fab fa-linkedin",
            link: "https://www.linkedin.com",
            title: "Linkedin",
        },
    ],
};

export default footerData;
